import React from "react";
import { Box } from "@mui/material";

const LogoImage = ({
  path = "/images/logos/6334AnalyticsADB.png",
  height = "100%",
  width = "auto",
  alt = "logo",
}) => {
  const logoSrc = path;
  return (
    <Box
      sx={{
        display: "grid",
        placeItems: "center",
        margin: "1rem 0.25rem",
        width: "auto",
        height: "auto",
        overflow: "hidden",
      }}
    >
      <img
        src={logoSrc}
        alt={alt}
        style={{
          height: height,
          width: width,
          maxWidth: "100%",
          objectFit: "contain",
        }}
      />
    </Box>
  );
};

export default LogoImage;
